module.exports = __webpack_public_path__ + "static/media/Hydreigon_gaussian2.5e2a9eeb.png";